var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"menu-icon",attrs:{"height":"100%","viewBox":"0 0 24 16"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24 2H0V0H24V2ZM24 9H0V7H24V9ZM0 16H24V14H0V16Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }